import { useMemo, useState } from "react";
import { works } from "@/mocks/community";
import SectionHeading from "./SectionHeading";

const genres = ["全部", "古风", "都市", "校园", "科幻", "日常", "奇幻"];

export default function Works() {
  const [active, setActive] = useState("全部");

  const list = useMemo(
    () => (active === "全部" ? works : works.filter((w) => w.genre.includes(active))),
    [active]
  );

  return (
    <section id="works" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="推荐作品"
          title="同好口碑榜 · 正在热追"
          desc="编辑部与同好联合推荐的热门佳作，无论入坑还是补番，都能在这里找到你的下一份心头好。"
        />

        <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
          {genres.map((g) => (
            <button
              key={g}
              type="button"
              onClick={() => setActive(g)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                active === g
                  ? "bg-primary-500 font-medium text-background-50"
                  : "bg-background-50 text-foreground-600 hover:bg-primary-100 hover:text-primary-700"
              }`}
            >
              {g}
            </button>
          ))}
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((work) => (
            <article
              key={work.id}
              className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:shadow-lg"
            >
              <div className="relative aspect-[3/4] w-full overflow-hidden">
                <img
                  src={work.cover}
                  alt={`${work.title} - ${work.genre} 作品封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute left-3 top-3 rounded-full bg-background-950/60 px-3 py-1 text-xs font-medium text-background-100 backdrop-blur-sm">
                  {work.status}
                </div>
                <div className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-bold text-background-50">
                  <i className="ri-star-fill text-[11px]"></i>
                  {work.score}
                </div>
              </div>

              <div className="p-4 md:p-5">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {work.title}
                  </h3>
                  <span className="whitespace-nowrap text-xs text-foreground-500">{work.genre}</span>
                </div>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                  {work.desc}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-book-open-line text-sm"></i>
                    {work.chapters}
                  </span>
                  <button
                    type="button"
                    className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-100 px-3.5 py-1.5 text-xs font-medium text-primary-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                  >
                    去围观
                    <i className="ri-arrow-right-line text-[13px]"></i>
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}